module.exports = __webpack_public_path__ + "static/media/gitTogether-details3.61a032b9.png";